import { useQuery } from '@tanstack/react-query';

import { fetchOrganizations } from '@account_module/services';
import { ORGANIZATION_QUERY_KEY } from '@account_module/constants/queryKeys';
import { IOrganization } from '@account_module/types/Organizations';

export const useOrganizations = () => {
  const { data, isLoading } = useQuery({
    queryKey: [ORGANIZATION_QUERY_KEY.organization, 'all'],
    queryFn: () => fetchOrganizations(),
  });

  const getOrganizationById = (id: string): IOrganization | undefined => {
    return data?.find((org: IOrganization) => org.id === id);
  };

  const getOrganizationByName = (name: string): IOrganization | undefined => {
    return data?.find((org: IOrganization) => org.name === name);
  };

  const getOrganizationByIndex = (index: number): IOrganization | undefined => {
    return data?.[index];
  };

  return {
    data,
    isLoading,
    getOrganizationById,
    getOrganizationByName,
    getOrganizationByIndex,
  };
};
